<template>
  <CommonModal>
    <SpinningLoader :pending="pending">
      <div
        :class="{ 'invisible' : !lot.lastBidUuid }"
        class="font-bold text-center"
      >
        {{ $t("lot.choose_bid") }} {{ lot.code }}
      </div>

      <div
        :class="{ 'invisible' : lot.lastBidUuid }"
        class="font-bold text-center"
      >
        {{ $t("lot.first_bid") }} {{ lot.code }}
      </div>

      <div
        :class="{ 'invisible' : !lot.lastBidUuid }"
        class="grid grid-cols-5 md:grid-cols-10 mt-2 text-base"
      >
        <div
          v-for="i in 10"
          :key="'bid-modal-' + i"
          class="cursor-pointer border h-[40px] w-[40px] py-2 text-center inline-block m-2"
          :class="{ 'bg-corepla-bg-dark': multiplier == i, 'text-white': multiplier == i }"
          @click="multiplier = i"
        >
          {{ i }}
        </div>
      </div>

      <div class="text-center text-sm">
        <div>
          {{ $t("lot.value") }} <span class="text-base font-bold">{{ lot.bidPrice }} €/t</span>
        </div>
        <div v-if="lot.lastBidUuid">
          <Translation keypath="lot.you_are_bidding">
            <span class="text-base font-bold">{{ multiplier }}</span>
          </Translation>
        </div>
      </div>

      <div class="absolute bottom-0 mb-5 w-full">
        <div class="flex justify-around">
          <div>
            <a
              href="#"
              class="btn btn-cancel"
              @click.prevent="$emit('close')"
            >{{ $t("common.close") }}</a>
          </div>
          <div>
            <a
              href="#"
              :disabled="multiplier"
              class="btn btn-cta"
              @click.prevent="bidSync"
            >{{ $t("common.relaunch") }}</a>
          </div>
        </div>
      </div>
    </SpinningLoader>
  </CommonModal>
</template>

<script setup>
import { ref } from 'vue';
import { Translation, useI18n } from 'vue-i18n'

import CommonModal from '@/components/CommonModal.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';
import { useNotificationsStore } from '@/stores/notifications';

const { pushSuccess, pushError } = useNotificationsStore();
const axios = useAxios()
const { t } = useI18n()

const pending = ref(false);

const emit = defineEmits(['close', 'update-auction'])
const props = defineProps({
    lot: {
        type: Object,
        required: true
    },
    myLot: {
        type: Object,
        required: true
    },
    auction: {
        type: Object,
        required: true
    }
})

const multiplier = ref(1)

const bidSync = async function () {
  pending.value = true;
  const url = props.lot.lastBidUuid ?
      '/auction/bid-sync/' + props.auction.uuid + '/' + props.lot.uuid + '/' + multiplier.value + '/' + props.lot.lastBidUuid :
      '/auction/bid-sync/' + props.auction.uuid + '/' + props.lot.uuid + '/1'
  
  await axios.post(url).then(bidResponse => {
    pushSuccess(t('lot.relaunch_with_successful'));
    emit('close');
    emit('update-auction', bidResponse.data);
  }).catch(error => {
    pushError(t('lot.relaunch_error'));
    pending.value = false;
    emit('close');
  });
}
</script>
